import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";

export default class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Módulo de Metas",
            user: {},
            unidades: [
                /*
                {
                    nome: "IST Automação Industrial",
                    nomeCRM: "IST AUTOMAÇÃO INDUSTRIAL",
                    sigla: "ISTAI",
                    path: "/istai"
                },
                */
                {
                    nome: "IST Têxtil e Confecções",
                    nomeCRM: "IST TÊXTIL E CONFECÇÕES",
                    sigla: "ISTTC",
                    path: "/isttc"
                },
                {
                    nome: "IST Eficiência Operacional",
                    nomeCRM: "IST EFICIÊNCIA OPERACIONAL",
                    sigla: "ISTEO",
                    path: "/isteo"
                }
            ]
        }
    }

    verificaSegundaUnidade = (user, unidade) => {
        let status = false;
        if(user.email === 'userteste@userteste.demo' && unidade.nomeCRM === 'IST TÊXTIL E CONFECÇÕES') status = true;
        return status;
    }

    verificaUnidade = (unidade) => {

        const user = JSON.parse(localStorage.getItem('user'));
        let unidadeUser = user.hasOwnProperty("unidade") && user.unidade;

        if(unidadeUser === unidade.nomeCRM || user.roles.indexOf("ROLE_ADMIN") > -1 || this.verificaSegundaUnidade(user, unidade) ) {
            return (
                <Fragment>
                    {/*<a href={"/sti" + unidade.path}><button type="button" className="btn btn-primary btn-block">{unidade.sigla}</button></a>*/}
                    <Link to={{ ...this.state, pathname: `/sti${unidade.path}` }}>
                        <button type="button" className="btn btn-primary btn-block">{unidade.sigla}</button>
                    </Link>
                </Fragment>
            )
        }
        else {
            return (
                <button type="button" className="btn btn-primary btn-block" onClick={this.onClick}>{unidade.sigla}</button>
            )
        }

    }

    onClick = (event) => {
        event.preventDefault();
        window.showNotification('Você não tem permissão para acessar essa unidade!', 'warning');
    }

    render() {
        return (
            <Fragment>
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="places-buttons">
                                        <div className="row">
                                            <div className="col-md-6 ml-auto mr-auto text-center">
                                                <h4 className="card-title"> Unidades
                                                    <p className="category">Escolha uma unidade</p>
                                                </h4>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-8 ml-auto mr-auto">
                                                <div className="row justify-content-center">
                                                    {this.state.unidades.map((unidade, key) => {
                                                        return (
                                                            <div key={key} className="col-md-3">
                                                                {this.verificaUnidade(unidade)}
                                                            </div>
                                                        )
                                                    })}
                                                    <div className="col-md-3">
                                                        <Link to={{ ...this.state, pathname: `/sti/dashboard` }}>
                                                            <button type="button" className="btn btn-primary btn-block"><i className="nc-icon nc-tile-56"></i> Relatórios</button>
                                                        </Link>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <a href="/sti/producaosti/relatorio3">
                                                            <button type="button" className="btn btn-primary btn-block"><i className="nc-icon nc-tile-56"></i> Produção</button>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}